import styled from 'styled-components'

export const HomePageWrapper = styled.div`
  background: white;
  padding: 1rem;
  width: 75%;
  margin: auto;
  text-align: center;
  min-height: 100vh;
  height: 100%;

  @media screen and (max-width: 1023px) {
    width: 100%;
  }
`

export const HomeContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
`
